import { useNavigate } from "react-router-dom";
import { useLazyGetCmsQuery } from "../../service/main";
import { useEffect, useState } from "react";
import { showError } from "../../constants/toasts";
import { log } from "console";
import Loader from "../../constants/Loader";

const TermsConditions = () => {
  const navigate = useNavigate();
  const [getCms] = useLazyGetCmsQuery();
  const [loading, setLoading] = useState(false);
  const [cmsData, setCmsData] = useState<{ termsAndConditions: string }>({
    termsAndConditions: "",
  });
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await getCms({}).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setCmsData(response?.data);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  return (
    <>
      <Loader isLoad={loading} />
      <div className="main_title">
        <h1>Terms and Conditions</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
          -Terms and Conditions
        </p>
      </div>
      <div className="cards terms">
        <p>{cmsData?.termsAndConditions || "No data found"}</p>
      </div>
    </>
  );
};
export default TermsConditions;
